import { render, staticRenderFns } from "./commonHeadImg.vue?vue&type=template&id=b295422a&scoped=true"
import script from "./commonHeadImg.vue?vue&type=script&lang=js"
export * from "./commonHeadImg.vue?vue&type=script&lang=js"
import style0 from "./commonHeadImg.vue?vue&type=style&index=0&id=b295422a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b295422a",
  null
  
)

export default component.exports